var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 86,
    viewBox: "0 0 116 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.5,
    cy: 69,
    rx: 41.5,
    ry: 17,
    fill: "#B9E8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9294 45.3082L82.4294 50.8082L70.9294 57.3082V62.3082L41.9294 79.3082L12.9294 62.3082L41.9294 45.3082Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30.4317L42.8904 25.9999L14.3801 39.8698L42.8904 53.7396L71.4006 39.8698L59 33.8371",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 62.5L42.5 79V54L27.5 64.5L15 58V62.5Z",
    fill: "#E5F6FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 26.5L15 39.5L42.5 53.5V26.5Z",
    fill: "#B9E8F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4294 25.8082V54.3082L70.9294 40.3082L42.4294 25.8082Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4294 53.3082V78.8082L70.4294 62.3082V57.8082L57.9294 64.8082L42.4294 53.3082Z",
    fill: "#7CCEE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 60V62",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 62L42.573 79.3082",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62L42.5729 79.3082",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70016 28.055L14.6757 39.7329",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3859 15.9114L1.97929 28.6969C1.62475 28.8511 1.21238 28.6886 1.05823 28.3341C0.904081 27.9795 1.06653 27.5672 1.42107 27.413L31.2497 14.444C31.5085 14.3243 31.8254 14.3711 32.0388 14.5845L43.068 25.6137C43.3413 25.887 43.3413 26.3302 43.068 26.6036C42.7946 26.877 42.3514 26.877 42.078 26.6036L31.3859 15.9114Z",
    fill: "#232F3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.77 28.055L74 38",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.42 14.5958L42.4022 25.6137C42.1289 25.887 42.1289 26.3302 42.4022 26.6036C42.6756 26.877 43.1188 26.877 43.3922 26.6036L54.0975 15.8983L54.7447 16.1518C55.1047 16.2928 55.5108 16.1153 55.6518 15.7553C55.7928 15.3953 55.6153 14.9892 55.2553 14.8482L54.1966 14.4335C54.1598 14.4181 54.122 14.4061 54.0836 14.3972C53.9826 14.3739 53.8803 14.3738 53.7831 14.3942C53.6456 14.4231 53.5183 14.493 53.42 14.5958ZM61.2209 19.0143C60.8664 18.8601 60.7039 18.4478 60.858 18.0932C61.0122 17.7387 61.4246 17.5762 61.7791 17.7304L84.0491 27.413C84.4037 27.5672 84.5661 27.9795 84.412 28.3341C84.2578 28.6886 83.8454 28.8511 83.4909 28.6969L61.2209 19.0143Z",
    fill: "#232F3E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 39.7329L8 45.2679M1.05128 50.7621L4 48.4306",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5729 53.7084L27.2595 64.4517L1.05131 50.7621",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1455 41.7329L86.0946 49.7621",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.573 53.7084L57.8864 64.4517L86.0946 49.7621",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5391 54.8351L42.5391 74.8694",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.539 30.1776V40.1776",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.539 44V48",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71 58V62",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33.8371L71.4006 39.8698L42.8904 53.7396L14.3801 39.8698L42.8904 25.9999L52 30.4317",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.238 12.6459C110.941 13.1657 111.409 13.828 111.614 14.4583C111.819 15.0898 111.75 15.646 111.461 16.0376C111.171 16.4291 110.66 16.6578 109.996 16.6469C109.333 16.6361 108.563 16.3821 107.86 15.8623C107.157 15.3425 106.688 14.6802 106.483 14.0499C106.278 13.4184 106.347 12.8622 106.636 12.4706C106.926 12.079 107.437 11.8504 108.101 11.8613C108.764 11.8721 109.535 12.1261 110.238 12.6459Z",
    fill: "white",
    stroke: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.359 16.7154C114.455 16.9581 114.383 17.3854 113.882 17.9438C113.404 18.4773 112.626 19.0133 111.656 19.397C110.685 19.7807 109.751 19.9213 109.037 19.8588C108.29 19.7935 107.945 19.5312 107.849 19.2886C107.753 19.046 107.826 18.6187 108.326 18.0602C108.805 17.5267 109.582 16.9907 110.553 16.607C111.524 16.2234 112.458 16.0828 113.171 16.1452C113.918 16.2105 114.263 16.4728 114.359 16.7154Z",
    fill: "#00A8E1",
    stroke: "#232F3E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.827 12.9322C113.922 13.8012 113.754 14.595 113.431 15.1733C113.106 15.7526 112.651 16.0799 112.167 16.1333C111.683 16.1866 111.168 15.9663 110.725 15.4716C110.283 14.9777 109.946 14.2395 109.851 13.3705C109.755 12.5015 109.923 11.7076 110.247 11.1294C110.571 10.5501 111.026 10.2228 111.51 10.1694C111.994 10.116 112.509 10.3364 112.952 10.8311C113.394 11.3249 113.731 12.0631 113.827 12.9322Z",
    fill: "white",
    stroke: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3874 40.5009C55.3343 34.3382 55.1782 17.8669 63.2352 8.95443C74.9129 -3.9632 91.2352 1.15886 86.9294 16.8081C84.7494 24.7316 74.3891 21.373 75.9294 13.3081C77.4295 5.45445 94.4294 3.30814 97.9294 14.3081C100.437 22.1888 96.4294 38.2012 107.443 34.8871C112.195 33.4575 112.587 27.3277 112.107 23.2552",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeDasharray: "2 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.93fd5857054efadea53210cecc452b41.svg";
export { ForwardRef as ReactComponent };